import { Injectable } from '@angular/core';
import { AppConfig } from './app.config';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class JsonAppConfigService extends AppConfig {

  constructor(private httpClient: HttpClient) {
    super();
   }

   load(){
     return this.httpClient.get<AppConfig>('app.config.json')
            .toPromise()
            .then(data => {
              this.backendUrl =data.backendUrl;
              this.authUrl = data.authUrl;
              this.env = data.env;
              this.logoPath = data.logoPath;
              this.bannerPath = data.bannerPath;
              this.testingMode = data.testingMode;
              this.AccessCodeExpiry = data.AccessCodeExpiry;
              this.LandingPageUrl = data.LandingPageUrl;
              this.ProductId=data.ProductId || this.ProductId;
              this.CompanyBranchId=data.CompanyBranchId || this.CompanyBranchId;
              this.OTACTemplateId = data.OTACTemplateId || this.OTACTemplateId;
            })
            .catch(err => {
              console.error('Could not load configuration');
            });
   }
}
